module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }, [_vm._v("‘"), _c('em', [_vm._v("The eagle of the Roman army goes at the head of every legion – the king of birds, most powerful of them all. . .")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "fmc1"
  }, [_vm._v("Josephus, "), _c('em', [_vm._v("Bellum Judiacum")]), _vm._v(", on the First Romano-Jewish War")]), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "fmc"
  }, [_vm._v("‘"), _c('em', [_vm._v("Laureolus gave up his naked flesh to a Caledonian bear . . .")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "fmc1"
  }, [_vm._v("Martial, "), _c('em', [_vm._v("Liber Spectaculorum")]), _vm._v(", on the inaugural games of the Colosseum")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 66
// module chunks = 0